<template>
  <div>
    <v-dialog v-if="type == 1" v-model="showDocument" persistent scrollable @keydown.esc="showDocument = false">
      <v-btn style="position: absolute; right: 20px; top: 20px; z-index: 100" fab dark small color="blue-grey" title="Закрыть окно" @click="showDocument = false">
        <v-icon dark> mdi-close </v-icon>
      </v-btn>
      <v-card style="position: absolute; top: 10px; left: 10px; right: 10px; bottom: 10px; width: auto; margin: auto" height="auto">
        <OrderGoods v-if="docName == 'OrderGoods' && showDocument" :idShow="idItemShow" :showOnly="true" />
        <OrderService v-else-if="docName == 'OrderService' && showDocument" :idShow="idItemShow" :showOnly="true" />
        <LoanGet v-else-if="docName == 'LoanGet' && showDocument" :idShow="idItemShow" :showOnly="!true" />
        <Task v-else-if="docName == 'Task' && showDocument" :idShow="idItemShow" :showOnly="!true" :api="api" />
        <Buying v-else-if="docName == 'Buying' && showDocument" :idShow="idItemShow" :showOnly="!true" />
        <ActWork v-else-if="docName == 'ActWork' && showDocument" :idShow="idItemShow" />
        <AgentSell v-else-if="docName == 'AgentSell' && showDocument" :idShow="idItemShow" :isQuickView="true" />
        <component v-else :is="docName" :ref="docName" :idShow="idItemShow"></component>
      </v-card>
    </v-dialog>
    <portal to="v-main">
      <ActWork v-if="docName == 'ActWork1'" ref="ActWork" v-model="showDocument" :idShow="idItemShow" />
      <CashDialog ref="cashDialog" />
    </portal>
  </div>
</template>

<script>
import { getAccess } from "@/components/mixings";

export default {
  mixins: [getAccess],
  components: {
    OrderGoods: () => import("@/views/documents/views/orderGoodsView"),
    OrderService: () => import("@/views/documents/views/orderServiceView"),
    LoanGet: () => import("@/views/documents/views/loanGetView"),
    CashDialog: () => import("@/views/documents/dialogs/cashDialog"),
    //ActWork: () => import("@/views/documents/dialogs/actWorkDialog"),
    ActWork: () => import("@/views/documents/views/actWorkView"),
    AgentSell: () => import("@/views/views/agentSellView"),
    ActWorkClient: () => import("@/views/documents/views/actWorkClientView"),
    Task: () => import("@/views/views/tasksView"),
    Buying: () => import("@/views/views/tasksBuyingView"),
  },
  props: {},
  data() {
    return {
      isQuickView_: true,
      idItemShow: 0,
      docName: "",
      showDocument: false,
      type: null,
      api: undefined,
    };
  },
  computed: {
    isQuickView() {
      return true;
    },
  },
  created() {},
  watch: {
    showDocument(v) {
      if (!v) {
        this.idItemShow = 0;
        this.docName = "";
        this.type = null;
        this.$emit("onClose");
      }
    },
  },
  methods: {
    async openDocument(name, id, row) {
      // console.log("openDocument", { name, id, row });
      if (name == "AccountingDocGettingLoan") {
        this.idItemShow = id;
        this.docName = "LoanGet";
        this.type = 1;
        this.showDocument = true;

        //       this.$refs.loanGet.openDialog(name, id); //передаю первым параметром модель, что бы там само определито тип документа
        return;
      } else if (name == "AccountingDocOrderWithdrawalModel") {
        return this.$refs.cashDialog.openDialog(name, id); //передаю первым параметром модель, что бы там само определито тип документа
        return;
      } else if (name == "AccountingDocOrderReceiptModel") {
        this.$refs.cashDialog.openDialog(name, id);
        //this.$refs.cashDialog.openDialog(row.operation_id, id);
        return;
      } else if (name == "AccountingDocOrderGoodModel") {
        this.idItemShow = id;
        this.docName = "OrderGoods";
        this.type = 1;
        this.showDocument = true;
        return;
      } else if (name == "AccountingDocOrderServiceModel") {
        this.idItemShow = id;
        this.docName = "OrderService";
        this.type = 1;
        this.showDocument = true;
        return;
      } else if (name == "AccountingDocActWork") {
        this.type = 2;
        this.type = 1;
        this.idItemShow = id;
        this.showDocument = true;
        this.docName = "ActWork";
        console.log(name, id, row);
        return;
      } else if (name == "AccountingDocActWorkClient") {
        this.type = 1;
        this.idItemShow = id;
        this.showDocument = true;
        this.docName = "ActWorkClient";
        console.log(name, id, row);
        return;
      } else if (name == "Tasks") {
        this.type = 1;
        this.idItemShow = id;
        this.showDocument = true;
        this.docName = "Task";
        this.api = row?._api;
        console.log(name, id, row);
        return;
      } else if (name == "Buying" || name == "AgentSell") {
        this.type = 1;
        this.idItemShow = id;
        this.showDocument = true;
        this.docName = name;
        console.log(name, id, row);
        return;
      } else {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Открытие этого документа в стадии разработки ",
        });
      }
    },
    itemShowClose() {},
  },
};
</script>
